import React from 'react';
import { Select, DatePicker } from 'antd';
import { moment } from '~helpers/day';
import AddonAfterNumberInput from '~pages/dashboard/referral/promotion/promotion-editor/addonAfterNumberInput';

const CombinedTimePicker = ({ value, onChange, enableActiveInFuture }) => {
  const handleSelectType = type => {
    onChange({
      selectedType: type,
      ...(type === 'futureRange' && { futureRange: [moment().startOf('day'), null] }),
    });
  };

  const handleChangeValue = v => {
    onChange({
      selectedType: value.selectedType,
      [value.selectedType]: v,
    });
  };

  return (
    <div className="combined-time-picker">
      <Select value={value.selectedType} onChange={handleSelectType}>
        <Select.Option value="range">Date Range</Select.Option>
        <Select.Option value="last">Last</Select.Option>
        <Select.Option value="on">On</Select.Option>
        {enableActiveInFuture && (
          <Select.Option value="futureRange">Active in the future</Select.Option>
        )}
      </Select>
      {value.selectedType === 'range' && (
        <DatePicker.RangePicker value={value.range} onChange={handleChangeValue} />
      )}
      {value.selectedType === 'last' && (
        <AddonAfterNumberInput
          addonAfter={'Days'}
          value={value.last}
          onChange={handleChangeValue}
        />
      )}
      {value.selectedType === 'on' && <DatePicker value={value.on} onChange={handleChangeValue} />}
      {value.selectedType === 'futureRange' && (
        <DatePicker.RangePicker value={value.futureRange} disabled />
      )}
    </div>
  );
};

export default CombinedTimePicker;
